import React, {memo, useEffect, useState, useCallback} from 'react';
import {useHistory} from 'react-router-dom';
import './index.scss';
import {onClickHandler} from '../../utils/onclick';
import {useNumpad} from '../../hooks/numpad';
import LockImage from '../../assets/images/bg/lock-screen.png';
import {useRPC} from '../../hooks/rpc';
import {setPasswordAction} from '../../store/control/actions';
import {useDispatch, useSelector} from 'react-redux';
import {useMessage} from "../../hooks/message";
import {useLocalization} from "../../hooks/localization";

let lockTimer;
export const LockScreen = memo(function LockScreen() {
    const [lockStatus, setLockStatus] = useState(false);
    const [isAborted, setIsAborted] = useState(false);
    const [renderNumpad, password, setPassword] = useNumpad(isAborted);
    const [rpc] = useRPC();
    const passStatus = useSelector(state => state.control.passwordStatus);
    const history = useHistory();
    const dispatch = useDispatch()
    const {failure} = useMessage();
    const {t} = useLocalization();

    useEffect(() => {
        if (passStatus) {
            dispatch(setPasswordAction(null))
            history.push('/');
        }else if (passStatus === false && password !== "") {
            setPassword("");
            failure(t("WRONG_PASSWORD"));
            dispatch(setPasswordAction(null))
        }
    }, [history, passStatus]);

    const openLockScreen = useCallback(() => {
        rpc.CheckAlarmPassword(password);
    }, [password, rpc]);

    const turnOffLockScreen = useCallback(() => {
        setLockStatus(true);
        setIsAborted(false);
        setPassword('');
    }, [setLockStatus, setIsAborted]);


    useEffect(() => {
        if (lockStatus) {
            lockTimer = setTimeout(() => {
                setLockStatus(false);
                setPassword('');
                console.log('Ekran Kilidi Başladı');
            }, 10000);
        }
        return () => {
            clearTimeout(lockTimer);
        };
    }, [lockStatus, setLockStatus, setPassword]);

    const screenTouchEvent = useCallback(() => {
        clearTimeout(lockTimer);
        if (lockStatus) {
            lockTimer = setTimeout(() => {
                setLockStatus(false);
                setPassword('');
                console.log('Ekran Kilidi Başladı');
            }, 10000);
        }
        return () => {
            clearTimeout(lockTimer);
        };
    }, [lockStatus, setLockStatus, setPassword]);


    return (
        <div className='lock-screen-container'>
            {
                lockStatus
                    ?
                    <div className="lock-screen-wrapper" {...onClickHandler(screenTouchEvent)}>
                        {renderNumpad()}
                        <div className="lock-screen-button-container">
                            <button className='lock-screen-button' {...onClickHandler(openLockScreen)}>{t('LOGIN')}</button>
                        </div>
                    </div>
                    :
                    <div className='lock-image-container' {...onClickHandler(turnOffLockScreen)}>
                        <img src={LockImage} alt={LockImage}/>
                    </div>
            }
        </div>
    );
});
